// extracted by mini-css-extract-plugin
export default {"input_box":"newsinput_input_box__HDDFi","input_form":"newsinput_input_form__D7Oal","input_label":"newsinput_input_label__Ulh9N","add_button":"newsinput_add_button__3mvXm"};